import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PhotosStep } from "@/components/sell/PhotosStep";
import { api, errMsg } from "@/lib/api";
import { NO_VISIT } from "@/lib/options";

export default function Upload() {
  const { token } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState(null);
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => { api.get(`/public/requests/${token}`).then((x) => setR(x.data)).catch((x) => setErr(errMsg(x))); }, [token]);
  const submit = async () => {
    if (busy) return;
    setBusy(true);
    try { await api.post(`/public/requests/${token}/submit`, { info: info || null }); setDone(true); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6" data-testid="upload-page">
        {err && <p className="text-destructive" role="alert" data-testid="upload-error">{err}</p>}
        {!r && !err && <p className="text-slate-500"><Loader2 className="mr-2 inline h-4 w-4 animate-spin" />Loading…</p>}
        {r && (done || r.completed) && (
          <div data-testid="upload-done">
            <h1 className="text-2xl font-bold text-slate-900">Thank you – we've received your details.</h1>
            <p className="mt-3 text-slate-700">We'll review them and be in touch. {NO_VISIT}</p>
          </div>
        )}
        {r && !done && !r.completed && (
          <>
            <p className="text-sm text-slate-600">Enquiry {r.reference} · <span className="plate-sm">{r.registration}</span> {r.vehicle}</p>
            {r.questions && <div className="mt-4 rounded-md border-l-2 border-brand-navy bg-white p-3 text-sm" data-testid="upload-questions"><p className="font-semibold">Our questions</p><p className="whitespace-pre-line">{r.questions}</p></div>}
            <div className="mt-6"><PhotosStep target={{ base: `/public/requests/${token}/photos`, initial: r.photos }} /></div>
            <label className="mt-6 block text-sm font-semibold text-slate-900" htmlFor="info">Anything else we should know? <span className="font-normal text-slate-500">(optional – e.g. service history, MOT, faults)</span></label>
            <textarea id="info" rows={4} maxLength={4000} className="field-input mt-2" value={info} onChange={(x) => setInfo(x.target.value)} data-testid="upload-info-input" />
            <Button size="lg" className="btn-cta mt-6 h-12 w-full text-base sm:w-auto" disabled={busy} onClick={submit} data-testid="upload-submit-button">{busy ? "Sending…" : "Send to Harrington's Direct"}</Button>
          </>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
